import {
  SurveyValidator,
  SurveyValidatorResult
} from 'core/builder/validators/SurveyValidator'

export class SurveyValidatorPages extends SurveyValidator {
  result(): Promise<SurveyValidatorResult[]> {
    const result: SurveyValidatorResult[] = []
    this.survey.pages.forEach((page) => {
      const duplicated = this.survey.pages.filter((p) => p.name === page.name)
      if (duplicated.length > 1) {
        result.push({
          pageName: page.name,
          level: 'ERROR',
          description: 'Page name is duplicated'
        })
      }
      if (page.elements.length === 0) {
        result.push({
          pageName: page.name,
          level: 'WARNING',
          description: 'No elements found'
        })
      }
    })
    return Promise.resolve(result)
  }
}
